import { segmentsAfter } from '../../components/FrostedGate/module-path';
import { ROUTES } from '../../constants/RouteNameMapping';

/** The shapes the KPI module takes per route tree; each frosts on its feature and imitates its own screens. */
export type KpiModuleVariant = 'consolidated' | 'consolidatedV2' | 'legacy' | 'managedServices';

export type KpiPreviewScreenKind = 'manage' | 'companies' | 'template' | 'requests' | 'responses';

export interface KpiPreviewScreen {
  kind: KpiPreviewScreenKind;
  /** The segment after the screen's own: a tab like `assigned`, or a template or configuration id. */
  tab?: string;
}

const TEMPLATE_SECTIONS = new Set<string>([
  ROUTES.KPI_CUSTOM_TEMPLATE_CONFIGURATION,
  ROUTES.KPI_DATA_COLLECTION_CONFIGURATION,
  ROUTES.KPI_TEMPLATES,
]);

/** The KPI screen a frosted module imitates at this path; anything unknown falls back to Manage Requests. */
export function kpiPreviewScreen(pathname: string): KpiPreviewScreen {
  const [section, tab] = segmentsAfter(pathname, ROUTES.KPI);

  switch (section) {
    case ROUTES.COMPANIES:
      return { kind: 'companies', tab };
    case ROUTES.KPI_REQUESTS:
      return { kind: 'requests', tab };
    case ROUTES.KPI_RESPONSES:
      return { kind: 'responses', tab };
    default:
      return section && TEMPLATE_SECTIONS.has(section) ? { kind: 'template', tab } : { kind: 'manage' };
  }
}
